export var DataLocationStorageType;
(function (DataLocationStorageType) {
    DataLocationStorageType["Cosmos"] = "Cosmos";
    DataLocationStorageType["AzureBlob"] = "AzureBlob";
    DataLocationStorageType["ADLSGen2"] = "ADLSGen2";
    DataLocationStorageType["MT"] = "MT";
    DataLocationStorageType["ADLSGen2CosmosView"] = "ADLSGen2CosmosView";
})(DataLocationStorageType || (DataLocationStorageType = {}));
export var DataLocationFileFormat;
(function (DataLocationFileFormat) {
    DataLocationFileFormat["Parquet"] = "Parquet";
    DataLocationFileFormat["CosmosView"] = "CosmosView";
})(DataLocationFileFormat || (DataLocationFileFormat = {}));
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["ManagedIdentity"] = "ManagedIdentity";
    AuthenticationType["Secret"] = "Secret";
    AuthenticationType["ServicePrincipal"] = "ServicePrincipal";
    AuthenticationType["Legacy"] = "Legacy";
})(AuthenticationType || (AuthenticationType = {}));
export var ColumnMultilineKey;
(function (ColumnMultilineKey) {
    ColumnMultilineKey["Name"] = "Name";
    ColumnMultilineKey["Type"] = "Type";
    ColumnMultilineKey["Value"] = "Value";
    ColumnMultilineKey["SampleValue"] = "SampleValue";
    ColumnMultilineKey["DoNotInherited"] = "DoNotInherited";
})(ColumnMultilineKey || (ColumnMultilineKey = {}));
export var parameterType;
(function (parameterType) {
    parameterType["SystemString"] = "System.String";
    parameterType["SystemBoolean"] = "System.Boolean";
    parameterType["SystemInt32"] = "System.Int32";
    parameterType["SystemInt64"] = "System.Int64";
    parameterType["SystemDouble"] = "System.Double";
    parameterType["CosmosDateNumber"] = "CosmosDateNumber";
})(parameterType || (parameterType = {}));

//# sourceMappingURL=DataSourceDataCommon.js.map
